import { DepositHistoryListResponse } from "../models/response/depositHistoryListResponse";
import { transactionsApi } from "../api/transactions.api";
import { DepositDetails } from "../models/response/lastDepositResponse";
import { ValidateTransactionUpdateResponse } from "../models/response/validateTransactionUpdateResponse";
import { DepositTransactionUpdateRequest } from "../models/request/depositTransactionUpdateRequest";
import { UploadDocumentRequest } from "../models/request/uploadDocumentRequest";
import { ApiDateFormatRequest } from "../../../models/Request/apiDateFormatRequest";
import { BalanceAdjustmentHistoryDetails } from "../models/response/balanceAdjustmentListResponse";
import { UserHistoryListRequest } from "../../../models/Request/userHistoryListRequest";
import { Withdrawhistorylistresponse } from "../models/response/withdrawHistoryListResponse";
import { LastWithdrawalResponse } from "../models/response/lastWithdrawalResponse";
import { Withdrawcancelrequest } from "../../../models/Request/withdrawCancelRequest";
import { WithdrawTransactionUpdateRequest } from "../models/request/withdrawTransactionUpdateRequest";
import { CasinoHistoryDetails } from "../models/response/casinoHistoryListResponse";
import { ExchangeHistoryDetails } from "../models/response/exchangeHistoryListResponse";
import { SportsHistoryDetails } from "../models/response/sportsHistoryListResponse";
import { BetByDetailsRequest } from "../models/request/betByDetailsRequest";
import { SportsHistorySummaryResponse } from "../models/response/sportsHistorySummaryResponse";
import errorModal from "../../../services/errorModal.service";

export async function getDepositHistory(request: ApiDateFormatRequest): Promise<DepositHistoryListResponse | null> {
    var response = await transactionsApi.getDepositHistory(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data ?? null;
}

export async function revertUserDepositById(depositId: string): Promise<boolean | null> {
    let data = await transactionsApi.revertUserDepositById(depositId);
    if (!data.isSuccess) {
        errorModal.showErrorModal(data.statusCode, data.message);
    }
    return data.isSuccess;
}

export async function getUserLastDeposit(): Promise<DepositDetails[] | null> {
    let result = await transactionsApi.getUserLastDeposit();
    if (!result.isSuccess) {
        errorModal.showErrorModal(result.statusCode, result.message);
    }
    return result.data?.details ?? null;
}

export async function validateUsersDepositTransactionUpdateById(depositId: string): Promise<ValidateTransactionUpdateResponse | null> {
    return await transactionsApi.validateUsersDepositTransactionUpdateById(depositId);
}

export async function addUsersDepositTransactionUpdateRequest(request: DepositTransactionUpdateRequest): Promise<boolean> {
    let data = await transactionsApi.addUsersDepositTransactionUpdateRequest(request);
    if (!data.isSuccess) {
        errorModal.showErrorModal(data.statusCode, data.message);
    }
    return data.isSuccess;
}

export async function uploadTransactionUpdateDocument(request: UploadDocumentRequest): Promise<string | null> {
    var response = await transactionsApi.uploadTransactionUpdateDocument(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data?.fileName ?? null;
}

export async function getAdjustmentHistory(request: ApiDateFormatRequest,): Promise<BalanceAdjustmentHistoryDetails[]> {
    var response = await transactionsApi.getAdjustmentHistory(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data?.details ?? [];
}

export async function getWithdrawHistory(request: UserHistoryListRequest): Promise<Withdrawhistorylistresponse | null> {
    var response = await transactionsApi.getWithdrawHistory(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data ?? null;
}

export async function getUserLastWithdrawal(): Promise<LastWithdrawalResponse | null> {
    var response = await transactionsApi.getUserLastWithdrawal();
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data ?? null;
}

export async function validateUsersWithdrawTransactionUpdateById(id: string): Promise<ValidateTransactionUpdateResponse | null> {
    return await transactionsApi.validateUsersWithdrawTransactionUpdateById(id);
}

export async function UserWithdrawRequestUpdateStatus(request: Withdrawcancelrequest): Promise<any> {
    let data = await transactionsApi.UserWithdrawRequestUpdateStatus(request);
    if (!data.isSuccess) {
        errorModal.showErrorModal(data.statusCode, data.message);
    }
    return data.isSuccess;
}

export async function addUsersWithdrawTransactionUpdateRequest(request: WithdrawTransactionUpdateRequest): Promise<boolean> {
    let data = await transactionsApi.addUsersWithdrawTransactionUpdateRequest(request);
    if (!data.isSuccess) {
        errorModal.showErrorModal(data.statusCode, data.message);
    }
    return data.isSuccess;
}

export async function UsersCasinoTransactionHistoryRequest(request: ApiDateFormatRequest): Promise<CasinoHistoryDetails[]> {
    var response = await transactionsApi.getUserCasinoTransectionHistory(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data?.details ?? [];
}

export async function UsersExchangeTransactionHistory(request: UserHistoryListRequest): Promise<ExchangeHistoryDetails[]> {
    var response = await transactionsApi.getUserExchangeTransectionHistory(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data?.details ?? [];
}

export async function getSportsHistory(request: UserHistoryListRequest): Promise<SportsHistoryDetails[]> {
    var response = await transactionsApi.getSportsHistory(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data?.details ?? [];
}

export async function getSportsBetHistoryDetails(request: BetByDetailsRequest): Promise<SportsHistorySummaryResponse[]> {
    var response = await transactionsApi.getSportsBetHistoryDetails(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data?.details ?? [];
}